/* eslint-disable indent */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Breadcrumb,
  Card,
  Row,
  Skeleton,
  Button,
  message,
  Modal,
  Table,
  Form,
} from 'antd';
import _ from 'lodash';
import OneRowData from 'components/OneRowData';
import { Link } from 'react-router-dom';
import ModalConfirmation from 'components/ModalConfirmation/ModalConfirmation.component';
import CallbackModal from 'components/CallbackModal/CallbackModal.component';
import { formatDateTimeDetail, formatMoney } from 'shared/utils/StringUtil';
import { permissionService } from 'shared/services';
import { CheckIcon, ErrorIcon } from '../../components/Icons';
import PrefixFormComponent from '../../components/PrefixForm/PrefixForm.components';
import TncPreviewModal from '../../components/TncPreviewModal/TncPreviewModal.component';
import billerRoute from '../../route';

import text from './BillerDetail.page.translation';
import './BillerDetail.style.less';

const PrefixForm = Form.create()(PrefixFormComponent);
const { checkPermission } = permissionService;

export default class BillerDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.prefixForm = React.createRef();
    this.preferredPrefixForm = React.createRef();
    this.state = {
      prefixModalVisible: false,
      confirmDeleteModalVisible: false,
      deleteErrorModalVisible: false,
      currentPage: 1,
      modalConfirm: {
        visible: false,
        content: 'Your Content Modal here',
        cancelText: 'Cancel',
        okText: 'Ok',
        onCancel: () => {},
        onProceed: () => {},
        confirmType: '',
      },
      callBackModal: {
        onClose: () => {},
        modalVisible: false,
        type: 'success',
        description: 'Hello World',
      },
      billerTypeInterpret: {
        1: 'Fixed Bank Code',
        2: 'Flexible Bank Code',
      },
      tncModalVisible: false,
    };
    this.selectedRow = {};
  }

  componentDidMount() {
    const billerID = this.props.match.params.id;
    this.props.getBiller(billerID, this.getBillerAction);
  }

  getBillerAction = (res, status) => {
    if (status === 'success') {
      const {
        biller: { biller_type: billerType, tnc },
        match: {
          params: { id: billerID },
        },
        getTncDetail,
        getListBank,
        getListBillerPrefix,
        getListBillerBankAccount,
        getListPaymentMethod,
        getChannelList,
        getNonMandatoryVaPrefixBankList,
      } = this.props;

      if (billerType === 3) {
        getListBillerBankAccount(billerID);
      } else {
        getListBillerPrefix(billerID);
      }

      const tncID = _.get(tnc, 'public_id');
      if (tncID) {
        getTncDetail(tncID);
      }

      const getListBankParam = {
        page_num: 1,
        page_size: 150,
      };
      getListBank(getListBankParam);
      getListPaymentMethod();
      getChannelList();
      getNonMandatoryVaPrefixBankList();
    }
  };

  _renderBreadCrumb = () => (
    <Breadcrumb>
      <Breadcrumb.Item>
        <Link to="/">Home</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <Link to={billerRoute.BILLERS}>Billers</Link>
      </Breadcrumb.Item>
      <Breadcrumb.Item>View Details</Breadcrumb.Item>
    </Breadcrumb>
  );

  _renderLeftData = () => {
    // Destruct Props
    const { loading, biller } = this.props;
    const { billerTypeInterpret } = this.state;

    let bbcValue = {
      label: '',
      value: '',
    };

    if (biller.beneficiary_bank && biller.biller_type === 1) {
      bbcValue = {
        label: 'Beneficiary Bank Code',
        value: `${biller.beneficiary_bank.bank_code} - ${biller.beneficiary_bank.name}`,
      };
    }

    const listLeftData = [
      {
        label: 'Billers ID',
        value: biller.public_id,
      },
      {
        label: 'Billers Name',
        value: biller.name,
      },

      {
        label: 'Biller Type',
        value: billerTypeInterpret[biller.biller_type] || '',
      },
      bbcValue,
      {
        label: 'Billers Icon',
        url: biller.icon_abs_url,
        style: {
          width: '38px',
          height: '38px',
          borderRadius: '2px',
        },
      },
      {
        label: 'Billers Banner',
        url: _.get(biller, 'banner_abs_url', []),
        inline: true,
        style: {
          width: '200px',
          height: '80px',
          borderRadius: '2px',
        },
      },
      {
        label: 'BillersURL',
        value: _.get(biller, 'page_url', ''),
        class: 'url-preview',
      },
      {
        label: 'IconURL',
        value: biller.icon_abs_url,
        class: 'url-preview',
      },
      {
        label: 'Playground Status',
        value: this.statusCase(biller.pground_status),
      },
      {
        label: 'Skywalker Status',
        value: this.statusCase(biller.skyw_status),
      },
    ];

    const listLeftSection = listLeftData.map(element => (
      <OneRowData key={element.label} data={element} />
    ));

    return (
      <Card.Grid className="card-grid-style minH210">
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 8,
            width: ['100%', '100%', '100%', '100%'],
          }}
          title={false}
        >
          {listLeftSection}
        </Skeleton>
      </Card.Grid>
    );
  };

  _renderRightData = () => {
    const { loading, biller } = this.props;
    const listRightData = [
      {
        label: 'Service Name',
        value: _.has(biller, 'service') ? biller.service.name : '-',
      },
      {
        label: 'Payment Method',
        value:
          _.has(biller, 'payment_method') && biller.payment_method !== null
            ? biller.payment_method.map((paymentMethod, index) => (
                <span
                  style={{
                    display: 'inline-block',
                    width: '100%',
                    textAlign: 'right',
                  }}
                  key={paymentMethod}
                >
                  {`${this.renderPaymentMethod(paymentMethod)}${
                    index < biller.payment_method.length - 1 ? ',' : ''
                  }`}
                  <br />
                </span>
              ))
            : '-',
      },
      {
        label: 'Transaction Fee',
        value: _.has(biller, 'transaction_fee')
          ? formatMoney(biller.transaction_fee)
          : '-',
      },
      {
        label: 'Related Form',
        value: _.has(biller, 'form') ? biller.form.name : '-',
      },
      {
        label: 'Terms & Condition Name',
        value: _.get(biller, 'tnc.name', '-'),
      },
      {
        label: 'Archived',
        value: !biller.archived_at ? 'No' : 'Yes',
      },
      {
        label: 'Created At',
        value: formatDateTimeDetail(biller.created_at || ''),
      },
      {
        label: 'Updated At',
        value: formatDateTimeDetail(biller.updated_at || ''),
      },
    ];
    const listRightSection = listRightData.map(element => (
      <OneRowData key={element.label} data={element} />
    ));

    return (
      <Card.Grid className="card-grid-style minH210">
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 8,
            width: ['100%', '100%', '100%', '100%'],
          }}
          title={false}
        >
          {listRightSection}
        </Skeleton>
      </Card.Grid>
    );
  };

  onRestoreBiller = () => {
    const makeContent = (
      <p>
        Are you sure want to <b>restore</b> this billers?
      </p>
    );
    const modalConfirm = {
      visible: true,
      content: makeContent,
      cancelText: 'Cancel',
      okText: 'Restore',
      onCancel: this.closeConfirm,
      onProceed: this.restoreBiller,
      confirmType: '',
    };
    this.setState({
      modalConfirm,
    });
  };

  restoreBiller = () => {
    // Show Loader
    message.loading({
      content: 'Restoring biller...',
      key: 'archiveLoader',
    });
    // Close Modal Confirm
    this.closeConfirm();
    // Set Archiving & Proceed to backend
    this.props.billerArchive(
      this.props.match.params.id,
      false,
      false,
      this.onActionArchive,
    );
  };

  closeConfirm = () => {
    const { modalConfirm } = this.state;
    const newState = { ...modalConfirm };
    newState.visible = false;
    this.setState({
      modalConfirm: newState,
    });
  };

  closeCallbackModal = () => {
    const { callBackModal } = this.state;
    const newState = { ...callBackModal };
    newState.modalVisible = false;
    this.setState({
      callBackModal: newState,
    });
  };

  onActionArchive = (id, isSuccess) => {
    const { callBackModal } = this.state;
    if (!isSuccess) {
      message.error({
        content:
          'Failed to restore biller, Please make sure service is not archive',
        key: 'archiveLoader',
      });
    }

    if (isSuccess) {
      this.props.getBiller(id, this.getBillerAction);
      message.destroy();
      const newState = { ...callBackModal };
      newState.type = 'success';
      newState.onClose = this.closeCallbackModal;
      newState.modalVisible = true;
      newState.description = `This billers has been restored`;
      this.setState({
        callBackModal: newState,
      });
    }
  };

  renderIndex = (t, r, index) => {
    let modifyIndex;
    const adjustIndex = index + 1;
    const { currentPage } = this.state;
    if (currentPage === 1) {
      modifyIndex = adjustIndex;
    } else {
      modifyIndex = adjustIndex + (currentPage - 1) * 5;
    }
    return modifyIndex;
  };

  statusCase = status => {
    switch (status) {
      case 2:
        return 'Active';
      case 1:
        return 'InActive';
      default:
        return 'Hidden';
    }
  };

  _getRowId = row => row.id;

  _tableColumns = () => {
    const {
      biller: { biller_type: billerType },
    } = this.props;

    const isBillerTypeBankAccount = billerType === 3;

    const tabBankAccount = {
      title: 'Bank Account',
      dataIndex: 'bank_account',
      key: 'bank_account',
    };

    const tabVaPrefix = {
      title: 'VA Prefix',
      dataIndex: 'va_prefix',
      key: 'va_prefix',
    };

    const tabAccount = isBillerTypeBankAccount ? tabBankAccount : tabVaPrefix;

    const tabDefaultBankAccount = {
      title: 'Default Bank Account',
      key: 'priority',
      align: 'center',
      render: this.renderDefaultPrefix,
    };

    const tabDefaultVaPrefix = {
      title: 'Default Prefix',
      key: 'priority',
      align: 'center',
      render: this.renderDefaultPrefix,
    };

    const tabDefaultAccount = isBillerTypeBankAccount
      ? tabDefaultBankAccount
      : tabDefaultVaPrefix;

    return [
      {
        title: 'No',
        key: 'index',
        render: this.renderIndex,
      },
      {
        title: 'Bank Code',
        dataIndex: 'bank_code',
        key: 'bank_code',
      },
      {
        title: 'Bank Name',
        dataIndex: 'bank_name',
        key: 'bank_name',
      },
      tabAccount,
      {
        title: 'Biller Code',
        dataIndex: 'biller_code',
        key: 'biller_code',
      },
      {
        title: 'Preferred Channel',
        dataIndex: 'preferred_channel',
        key: 'preferred_channel',
      },
      {
        title: 'Backup Channel',
        dataIndex: 'backup_channel',
        key: 'backup_channel',
      },
      tabDefaultAccount,
      {
        title: 'Action',
        key: 'action',
        render: this.renderAction,
      },
    ];
  };

  _renderTablePrefix = () => {
    const {
      loadingPrefix,
      listBillerPrefix,
      listBillerBankAccount,
      biller: { biller_type: billerType },
    } = this.props;
    const localeSetting = {
      emptyText: 'No Data',
    };
    const dataSource =
      billerType === 3 ? listBillerBankAccount : listBillerPrefix;

    return (
      <div className="table-wrapper">
        <Table
          rowID={this._getRowId}
          rowKey={this._getRowId}
          columns={this._tableColumns()}
          dataSource={dataSource}
          pagination={{ pageSize: 5, position: 'bottom' }}
          rowClass="striped-table"
          totalItem={1}
          loading={loadingPrefix}
          onChange={this._onChangePage}
          locale={localeSetting}
        />
      </div>
    );
  };

  isListBillerEmpty = () => {
    const {
      listBillerBankAccount,
      listBillerPrefix,
      biller: { biller_type: billerType },
    } = this.props;

    if (billerType === 3) {
      return (
        listBillerBankAccount === undefined || listBillerBankAccount.length < 1
      );
    }
    return listBillerPrefix === undefined || listBillerPrefix.length < 1;
  };

  _onChangePage = data => {
    this.setState({ currentPage: data.current });
  };

  renderPaymentMethod = method => {
    const { listPaymentMethod } = this.props;
    let label = method;
    if (listPaymentMethod.length > 0) {
      // eslint-disable-next-line
       const matchObject = listPaymentMethod.filter(function(item) {
        return item.id === method;
      });
      if (matchObject.length > 0) label = matchObject[0].label;
    }
    return label;
  };

  renderDefaultPrefix = (t, r, index) => {
    if (this.state.currentPage === 1 && index === 0) {
      return <CheckIcon />;
    }
    return null;
  };

  renderAction = (t, row) => (
    <div
      style={{ color: '#108ee9', cursor: 'pointer' }}
      onClick={() => {
        this._editAccount(row);
      }}
    >
      Edit
    </div>
  );

  _addAccount = () => {
    this.selectedRow = {};
    this.setState({ prefixModalVisible: true });
  };

  _editAccount = row => {
    const {
      listBillerPrefix,
      listBillerBankAccount,
      biller: { biller_type: billerType },
    } = this.props;

    const dataSource =
      billerType === 3 ? listBillerBankAccount : listBillerPrefix;

    this.selectedRow = row;
    this.selectedRowIndex = _.findIndex(dataSource, { id: row.id });

    this.setState({ prefixModalVisible: true });
  };

  resetSelectedRow = () => {
    this.selectedRow = {};
    this.selectedRowIndex = -1;
  };

  _renderModalPrefix = () => {
    const {
      loadingPrefix,
      listBank,
      biller: { biller_type: billerType },
      channelList,
      nonMandatoryVaPrefixBankList,
    } = this.props;
    const { prefixModalVisible } = this.state;
    const isEditAccount = this.selectedRowIndex > -1;

    const bankAccountForm = (
      <PrefixForm
        ref={this.prefixForm}
        listBank={listBank}
        submitPrefix={
          isEditAccount
            ? this.billerBankAccountEdit
            : this.billerBankAccountCreate
        }
        billerType={billerType}
        row={this.selectedRow}
        isEditAccount={isEditAccount}
        isListBillerEmpty={this.isListBillerEmpty()}
        billerDelete={this.billerDelete}
        channelList={channelList}
        nonMandatoryVaPrefixBankList={nonMandatoryVaPrefixBankList}
      />
    );

    const vaPrefixForm = (
      <PrefixForm
        ref={this.prefixForm}
        listBank={listBank}
        submitPrefix={
          isEditAccount ? this.billerPrefixEdit : this.billerPrefixCreate
        }
        billerType={billerType}
        row={this.selectedRow}
        isEditAccount={isEditAccount}
        isListBillerEmpty={this.isListBillerEmpty()}
        billerDelete={this.billerDelete}
        channelList={channelList}
        nonMandatoryVaPrefixBankList={nonMandatoryVaPrefixBankList}
      />
    );

    const bankAccountTitle = isEditAccount
      ? 'Edit Bank Account'
      : 'Add Bank Account';
    const prefixTitle = isEditAccount ? 'Edit Prefix' : 'Add Prefix';
    let title = '';
    if (prefixModalVisible) {
      title = billerType === 3 ? bankAccountTitle : prefixTitle;
    }

    const renderedForm = billerType === 3 ? bankAccountForm : vaPrefixForm;

    return (
      <Modal
        className="prefix-modal"
        title={title}
        visible={prefixModalVisible}
        confirmLoading={loadingPrefix}
        onCancel={this._prefixModalCancel}
        footer={[
          <Button
            form="prefixForm"
            htmlType="submit"
            key="add"
            type="primary"
            loading={loadingPrefix}
          >
            {isEditAccount ? 'Save' : 'Add'}
          </Button>,
          isEditAccount && (
            <Button
              className="button-remove"
              form="prefixForm"
              htmlType="reset"
              key="remove"
              type="primary"
              loading={loadingPrefix}
            >
              Remove
            </Button>
          ),
          <Button
            key="cancel"
            htmlType="reset"
            disabled={loadingPrefix}
            onClick={this._prefixModalCancel}
          >
            Cancel
          </Button>,
          <div className="span-prefix-modal-footer">(*) Mandatory Field</div>,
        ]}
      >
        {prefixModalVisible && renderedForm}
      </Modal>
    );
  };

  _prefixModalCancel = () => {
    this.prefixForm.current.resetFields();
    this.resetSelectedRow();
    this.setState({
      prefixModalVisible: false,
    });
  };

  retainFilledFormData = value => {
    const params = {
      id: value.id,
      bank_id: value.bank_id,
      bank_code: value.bank_code,
      va_prefix: value.va_prefix,
      bank_account: value.bank_account,
      preferred_channel: value.preferred_channel,
      biller_code: value.biller_code,
      backup_channel: value.backup_channel,
      is_default_prefix: value.is_default_prefix,
    };

    // To retain the data when the form is closed
    this.selectedRow = params;
  };

  billerPrefixCreate = value => {
    const billerID = this.props.match.params.id;

    this.retainFilledFormData(value);

    const params = {
      bank_id: value.bank_id,
      biller_id: billerID,
      va_prefix: value.va_prefix,
      preferred_channel: value.preferred_channel,
      biller_code: value.biller_code,
      backup_channel: value.backup_channel,
    };

    const isDefaultPrefix = value.is_default_prefix;

    if (isDefaultPrefix) {
      params.priority = '1';
    }
    // Show confirmation set as default prefix
    // when creating prefix and set as default prefix

    if (isDefaultPrefix && !this.isListBillerEmpty()) {
      this.preferredPrefixChangedConfirmationModal(false, () => {
        params.priority = '1';
        this.props.billerCreatePrefix(
          params,
          this.callBackPrefixActions('create'),
        );
      });
    } else {
      this.props.billerCreatePrefix(
        params,
        this.callBackPrefixActions('create'),
      );
    }
  };

  billerBankAccountCreate = value => {
    const billerID = this.props.match.params.id;

    this.retainFilledFormData(value);

    const params = {
      bank_id: value.bank_id,
      biller_id: billerID,
      bank_account: value.bank_account,
    };

    const isDefaultPrefix = value.is_default_prefix;

    // Show confirmation set as default prefix
    // when creating prefix and set as default prefix
    if (isDefaultPrefix && !this.isListBillerEmpty()) {
      this.preferredPrefixChangedConfirmationModal(true, () => {
        this.props.billerCreateBankAccount(
          params,
          this.callBackPrefixActions('create', isDefaultPrefix),
        );
      });
    } else {
      this.props.billerCreateBankAccount(
        params,
        this.callBackPrefixActions('create'),
      );
    }
  };

  billerPrefixEdit = value => {
    value.id = this.selectedRow.id;
    value.biller_id = this.props.match.params.id;

    this.retainFilledFormData(value);

    if (value.is_default_prefix && this.selectedRowIndex > 0) {
      value.priority = '1';
      this.preferredPrefixChanged(value);
    } else {
      this.resetSelectedRow();
      this.props.billerEditPrefix(value, this.callBackPrefixActions('edit'));
      this.setState({ prefixModalVisible: false });
    }
  };

  billerBankAccountEdit = value => {
    value.id = this.selectedRow.id;
    this.retainFilledFormData(value);

    if (value.is_default_prefix && this.selectedRowIndex > 0) {
      this.preferredBankAccountChanged(this.selectedRow.id);
    } else {
      this.resetSelectedRow();
      this.setState({ prefixModalVisible: false });
    }
  };

  billerDelete = value => {
    value.id = this.selectedRow.id;
    this.retainFilledFormData(value);

    if (this.selectedRowIndex === 0) {
      this.setState({
        prefixModalVisible: false,
        deleteErrorModalVisible: true,
      });
    } else {
      this.setState({
        prefixModalVisible: false,
        confirmDeleteModalVisible: true,
      });
    }
  };

  renderConfirmDeleteModal = () => {
    const { confirmDeleteModalVisible } = this.state;
    const {
      biller: { biller_type: billerType },
    } = this.props;

    const removedItem = billerType === 3 ? 'bank account' : 'prefix';

    return (
      <Modal
        className="confirm-delete-modal"
        title="Confirmation"
        visible={confirmDeleteModalVisible}
        onCancel={this.cancelConfirmDeleteModal}
        footer={[
          <Button key="cancel" onClick={this.cancelConfirmDeleteModal}>
            Cancel
          </Button>,
          <Button
            className="button-remove"
            key="remove"
            type="primary"
            onClick={this.onConfirmDelete}
          >
            Remove
          </Button>,
        ]}
      >
        <p>
          Are you sure you want to <strong>remove {removedItem}?</strong>
        </p>
      </Modal>
    );
  };

  cancelConfirmDeleteModal = () => {
    this.setState({
      confirmDeleteModalVisible: false,
      prefixModalVisible: true,
    });
  };

  onConfirmDelete = () => {
    const {
      biller: { biller_type: billerType },
    } = this.props;

    this.setState(
      {
        confirmDeleteModalVisible: false,
      },
      () => {
        if (billerType === 3) {
          this.billerBankAccountDelete(this.selectedRow.id);
        } else {
          this.billerPrefixDelete(this.selectedRow.id);
        }
      },
    );
  };

  renderDeleteErrorModal = () => {
    const { deleteErrorModalVisible } = this.state;
    const {
      biller: { biller_type: billerType },
    } = this.props;

    const removedItem = billerType === 3 ? 'bank account' : 'prefix';

    return (
      <Modal
        className="delete-error-modal"
        visible={deleteErrorModalVisible}
        onCancel={this.closeDeleteErrorModal}
        footer={[
          <Button
            className="button-confirm"
            type="primary"
            key="confirm"
            onClick={this.closeDeleteErrorModal}
          >
            OK
          </Button>,
        ]}
      >
        <div className="error-icon">
          <ErrorIcon />
        </div>
        <span className="title">ERROR</span>
        <p>
          Can’t remove {removedItem} because {removedItem} is a{' '}
          <strong>
            Default {removedItem}.<br></br>
          </strong>{' '}
          Try change the default {removedItem} and try again.
        </p>
      </Modal>
    );
  };

  closeDeleteErrorModal = () => {
    this.setState({ deleteErrorModalVisible: false, prefixModalVisible: true });
  };

  billerBankAccountDelete = bankAccountID => {
    this.props.billerDeleteBankAccount(
      bankAccountID,
      this.onActionBankAccountDelete,
    );
  };

  onActionBankAccountDelete = (res, status) => {
    this.resetSelectedRow();

    if (status === 'success') {
      const billerID = this.props.match.params.id;
      this.props.getListBillerBankAccount(billerID);
      message.success({
        content: 'Success Removing Bank Account',
        key: 'deleteBankAccount',
      });
    } else {
      message.error({
        content: 'Error Removing Bank Account',
        key: 'deleteBankAccount',
      });
    }
  };

  billerPrefixDelete = prefixID => {
    this.props.billerDeletePrefix(prefixID, this.onActionPrefixDelete);
  };

  onActionPrefixDelete = (res, status) => {
    this.resetSelectedRow();

    if (status === 'success') {
      const billerID = this.props.match.params.id;
      this.props.getListBillerPrefix(billerID);
      message.success({
        content: 'Success Removing Prefix',
        key: 'deletePrefix',
      });
    } else {
      message.error({ content: 'Error Removing Prefix', key: 'deletePrefix' });
    }
  };

  preferredPrefixChangedConfirmationModal = (isBankAccount, callback) => {
    this.setState({
      prefixModalVisible: false,
      modalConfirm: {
        visible: true,
        content: !isBankAccount ? (
          <p>
            Are you sure want to <strong>set as default prefix?</strong>
          </p>
        ) : (
          <p>
            Are you sure want to <strong>set as default bank account?</strong>
          </p>
        ),
        cancelText: 'Cancel',
        okText: 'Save',
        onCancel: () => {
          this.setState({
            prefixModalVisible: true,
            modalConfirm: {
              visible: false,
              conftent: '',
              onProceed: () => {},
            },
          });
        },
        onProceed: () => {
          callback();
        },
        confirmType: '',
      },
    });
  };

  preferredPrefixChanged = newDefaultPrefix => {
    this.setState({
      prefixModalVisible: false,
      modalConfirm: {
        visible: true,
        content: (
          <p>
            Are you sure want to <strong>set as default prefix?</strong>
          </p>
        ),
        cancelText: 'Cancel',
        okText: 'Save',
        onCancel: () => {
          this.setState({
            prefixModalVisible: true,
            modalConfirm: {
              visible: false,
              conftent: '',
              onProceed: () => {},
            },
          });
        },
        onProceed: () => {
          this.props.billerEditPrefix(
            newDefaultPrefix,
            this.callBackPrefixActions('default'),
          );
        },
        confirmType: '',
      },
    });
  };

  preferredBankAccountChanged = newDefaultBankAccount => {
    this.setState({
      prefixModalVisible: false,
      modalConfirm: {
        visible: true,
        content: (
          <p>
            Are you sure want to <strong>set as default bank account?</strong>
          </p>
        ),
        cancelText: 'Cancel',
        okText: 'Save',
        onCancel: () => {
          this.setState({
            prefixModalVisible: true,
            modalConfirm: {
              visible: false,
              conftent: '',
              onProceed: () => {},
            },
          });
        },
        onProceed: () => {
          this.props.billerUpdatePreferredBankAccount(
            newDefaultBankAccount,
            this.callBackPrefixActions('default'),
          );
        },
        confirmType: '',
      },
    });
  };

  callBackPrefixActions = key => (res, status) => {
    const {
      biller: { biller_type: billerType },
      match: {
        params: { id: billerID },
      },
    } = this.props;

    let prefixCallbackModalDesc;
    let bankAccountCallbackModalDesc;

    const isFixedBankAccount = billerType === 3;

    if (status === 'success') {
      if (isFixedBankAccount) {
        this.props.getListBillerBankAccount(billerID);
      } else {
        this.props.getListBillerPrefix(billerID);
      }

      switch (key) {
        case 'create':
          prefixCallbackModalDesc = 'New Prefix Added';
          bankAccountCallbackModalDesc = 'New Bank Account Is Added';
          break;
        case 'edit':
          prefixCallbackModalDesc = 'This prefix has been updated';
          bankAccountCallbackModalDesc = 'This bank account has been updated';
          break;
        default:
          prefixCallbackModalDesc = 'Default prefix has been changed';
          bankAccountCallbackModalDesc =
            'Default bank account has been changed';
      }

      const prefixCallBackModal = {
        type: 'success',
        onClose: this.closeCallbackModal,
        modalVisible: true,
        description: prefixCallbackModalDesc,
      };

      const bankAccountCallBackModal = {
        type: 'success',
        onClose: this.closeCallbackModal,
        modalVisible: true,
        description: bankAccountCallbackModalDesc,
      };

      this.setState(
        {
          prefixModalVisible: false,
          modalConfirm: {
            visible: false,
            conftent: '',
            onProceed: () => {},
          },
          callBackModal: isFixedBankAccount
            ? bankAccountCallBackModal
            : prefixCallBackModal,
        },
        () => {
          this.resetSelectedRow();
        },
      );
    } else {
      switch (key) {
        case 'create':
          prefixCallbackModalDesc = 'Failed to Add Prefix';
          bankAccountCallbackModalDesc = 'Failed to Add Bank Account';
          break;
        case 'edit':
          prefixCallbackModalDesc = 'Failed to update this prefix';
          bankAccountCallbackModalDesc = 'Failed to update this bank account';
          break;
        default:
          prefixCallbackModalDesc = 'Failed to change preferred prefix';
          bankAccountCallbackModalDesc =
            'Failed to change preferred bank account';
      }

      const prefixCallBackModal = {
        type: 'failed',
        onClose: this.closeCallbackModal,
        modalVisible: true,
        description: prefixCallbackModalDesc,
      };

      const bankAccountCallBackModal = {
        type: 'failed',
        onClose: this.closeCallbackModal,
        modalVisible: true,
        description: bankAccountCallbackModalDesc,
      };

      this.setState({
        prefixModalVisible: false,
        modalConfirm: {
          visible: false,
          conftent: '',
          onProceed: () => {},
        },
        callBackModal: isFixedBankAccount
          ? bankAccountCallBackModal
          : prefixCallBackModal,
      });
    }
  };

  _renderEditRestoreButton = () => {
    const { loading, biller, match } = this.props;
    const tncID = _.get(biller, 'tnc.public_id');

    let button = (
      <Link to={`edit/${match.params.id}`}>
        <Button type="primary" className="submit-button" disabled={loading}>
          Edit
        </Button>
      </Link>
    );

    if (biller.archived_at) {
      button = (
        <Button
          type="primary"
          className="submit-button"
          onClick={this.onRestoreBiller}
        >
          Restore
        </Button>
      );
    }

    return (
      <div className="edit-separator">
        {button}
        {tncID && (
          <Button
            type="primary"
            className="submit-button"
            onClick={this.handleViewTermsCondition}
          >
            View Terms & Conditions
          </Button>
        )}
      </div>
    );
  };

  handleViewTermsCondition = () => {
    this.setState({ tncModalVisible: true });
  };

  render() {
    const {
      intl: { formatMessage },
      loading,
      biller: { biller_type: billerType },
      tnc,
    } = this.props;

    const titleText =
      billerType === 3 ? 'Bank Account Details' : 'Bank VA Prefix Details';
    return (
      <div className="main-content view-biller">
        <div className="breadcrumb-wrapper">{this._renderBreadCrumb()}</div>
        <div className="white-box-wrapper">
          <div className="title-head">
            <span className="title">{formatMessage(text.billerView)}</span>
          </div>

          <Card bordered={false}>
            <Row type="flex">
              {this._renderLeftData()}
              {this._renderRightData()}
            </Row>
          </Card>

          {checkPermission('Biller:update', true) &&
            this._renderEditRestoreButton()}
        </div>
        <div className="white-box-wrapper">
          <div className="prefix-title">
            <span className="title-text">{titleText}</span>
            <div>
              <Button
                type="primary"
                size="large"
                disabled={loading}
                onClick={this._addAccount}
              >
                {billerType === 3 ? 'Add Bank Account' : 'Add Prefix'}
              </Button>
            </div>
          </div>

          <Card bordered={false}>{this._renderTablePrefix()}</Card>
        </div>
        {this._renderModalPrefix()}
        {this.renderConfirmDeleteModal()}
        {this.renderDeleteErrorModal()}
        <ModalConfirmation {...this.state.modalConfirm} />
        <CallbackModal {...this.state.callBackModal} />
        <TncPreviewModal
          showControl
          title="Terms & Conditions"
          modalVisible={this.state.tncModalVisible}
          onClose={() => {
            this.setState({ tncModalVisible: false });
          }}
          tnc={{
            name: _.get(tnc, 'name'),
            fileVersion: _.get(tnc, 'latest_version.name'),
            tncContent: _.get(tnc, 'content'),
          }}
        />
      </div>
    );
  }
}

BillerDetail.propTypes = {
  match: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  getBiller: PropTypes.func.isRequired,
  getListBillerPrefix: PropTypes.func.isRequired,
  listBillerPrefix: PropTypes.array,
  biller: PropTypes.object,
  loading: PropTypes.bool,
  loadingPrefix: PropTypes.bool,
  billerDeletePrefix: PropTypes.func,
  billerCreatePrefix: PropTypes.func,
  getListBank: PropTypes.func,
  billerArchive: PropTypes.func,
  listBank: PropTypes.array,
  updatePreferredPrefix: PropTypes.func,
  billerEditPrefix: PropTypes.func,
  listBillerBankAccount: PropTypes.array,
  getListBillerBankAccount: PropTypes.func,
  billerCreateBankAccount: PropTypes.func,
  billerUpdatePreferredBankAccount: PropTypes.func,
  billerDeleteBankAccount: PropTypes.func,
  tnc: PropTypes.object,
  getTncDetail: PropTypes.func,
  getListPaymentMethod: PropTypes.func,
  listPaymentMethod: PropTypes.array,
  getChannelList: PropTypes.func,
  channelList: PropTypes.array,
  getNonMandatoryVaPrefixBankList: PropTypes.func,
  nonMandatoryVaPrefixBankList: PropTypes.array,
};
